import { onDocumentReady } from '../utils/events';

onDocumentReady(() => {
  const menuButton = document.querySelector('.menu-icon');
  const menu = document.getElementById('main-menu');
  const headerMenu = menu?.querySelector('.header-menu');
  const desktopMedia = window.matchMedia('(min-width: 1024px)');

  if (!menuButton || !menu || !headerMenu) return;

  const parentItems = Array.from(
    headerMenu.querySelectorAll('li.menu-item-has-children')
  );

  const setSubmenuState = (item, isOpen) => {
    const toggle = item.querySelector(':scope > .dropdown-toggle');
    const submenu = item.querySelector(':scope > .submenu');

    if (isOpen && submenu) {
      submenu.style.setProperty(
        '--submenu-height',
        `${submenu.scrollHeight}px`
      );
    }

    item.classList.toggle('open', isOpen);
    toggle?.setAttribute('aria-expanded', String(isOpen));
  };

  const syncOpenSubmenuHeights = () => {
    Array.from(headerMenu.querySelectorAll('li.open'))
      .reverse()
      .forEach((item) => {
        const submenu = item.querySelector(':scope > .submenu');

        if (submenu) {
          submenu.style.setProperty(
            '--submenu-height',
            `${submenu.scrollHeight}px`
          );
        }
      });
  };

  const closeSubmenus = () => {
    parentItems.forEach((item) => setSubmenuState(item, false));
  };

  const closeMenu = () => {
    menuButton.classList.remove('is-active');
    menuButton.setAttribute('aria-expanded', 'false');
    menu.classList.remove('is-active');
    document.body.classList.remove('menu-open');
    closeSubmenus();
  };

  menuButton.setAttribute('aria-controls', 'main-menu');
  menuButton.setAttribute('aria-expanded', 'false');

  parentItems.forEach((item, index) => {
    const link = item.querySelector(':scope > a');
    const submenu = item.querySelector(':scope > .submenu');

    if (!link || !submenu) return;

    const submenuId = submenu.id || `header-submenu-${index + 1}`;
    submenu.id = submenuId;
    link.setAttribute('aria-haspopup', 'true');

    let toggle = item.querySelector(':scope > .dropdown-toggle');

    if (!toggle) {
      toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'dropdown-toggle';
      item.insertBefore(toggle, submenu);
    }

    toggle.setAttribute('aria-controls', submenuId);
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute(
      'aria-label',
      `Toggle submenu: ${link.textContent.trim()}`
    );

    toggle.addEventListener('click', () => {
      const shouldOpen = !item.classList.contains('open');

      Array.from(item.parentElement?.children || []).forEach((sibling) => {
        if (sibling !== item && sibling.matches('.menu-item-has-children')) {
          setSubmenuState(sibling, false);
        }
      });

      setSubmenuState(item, shouldOpen);
      window.requestAnimationFrame(syncOpenSubmenuHeights);
    });
  });

  menuButton.addEventListener('click', () => {
    const isOpen = !menu.classList.contains('is-active');

    menuButton.classList.toggle('is-active', isOpen);
    menuButton.setAttribute('aria-expanded', String(isOpen));
    menu.classList.toggle('is-active', isOpen);
    document.body.classList.toggle('menu-open', isOpen);

    if (!isOpen) closeSubmenus();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    closeMenu();
    menuButton.focus();
  });

  document.addEventListener('click', (event) => {
    if (
      desktopMedia.matches ||
      !menu.classList.contains('is-active') ||
      event.target.closest('.header')
    ) {
      return;
    }

    closeMenu();
  });

  desktopMedia.addEventListener('change', () => {
    closeMenu();
    parentItems.forEach((item) => {
      const submenu = item.querySelector(':scope > .submenu');
      submenu?.removeAttribute('style');
    });
  });

  window.addEventListener('resize', () => {
    if (!desktopMedia.matches) syncOpenSubmenuHeights();
  });
});
